// src/pages/About.jsx
import SectionTitle from '../components/common/SectionTitle';
import Button from '../components/common/Button';
import DoctorProfile from '../components/about/DoctorProfile';
import Stats from '../components/about/Stats';
import clinic from '../Assets/TeamandOthers/Sridhardental.webp'
const About = () => {
  
  return (
    <main className="pt-20 pb-16">
      {/* Hero-like banner */}
      <section className="bg-blue-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-blue-800 mb-6">
            About Dr. Sridhar International Dental Clinic
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Established in 1995 under the leadership of Dr. Arumalla Sridhar Reddy – 
            One of the most sophisticated and trusted dental healthcare providers in South India.
          </p>
        </div>
      </section>

      {/* Leadership / Doctor Profile */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <SectionTitle 
            title="Leadership" 
            subtitle="Dr. Arumalla Sridhar Reddy – 25+ Years of Excellence"
          />
          <DoctorProfile />
        </div>
      </section>

      {/* About Clinic */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-blue-800 mb-6">
                Premium Dental Care Since 1995
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Headquartered in Hyderabad, Sridhar International Dental Clinic was established in 1995 
                with the best offerings in dental care. In 25+ years of our journey, we evolved as 
                premium dental health care providers with the integration of state-of-the-art facilities 
                and digital dentistry. We have served countless clients and helped bring back their confident smiles.
              </p>
              <Button>Explore Our Journey →</Button>
            </div>
            <img 
              src={clinic} 
              alt="Dr. Sridhar Dental Clinic" 
              className="rounded-xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Stats */}
      <Stats />

      {/* Technology Highlights */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <SectionTitle title="Our Advanced Technology" />
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 border rounded-lg hover:shadow-lg transition">
              <div className="text-5xl text-blue-600 mb-4">CEREC</div>
              <h3 className="text-xl font-bold mb-2">CEREC CAD/CAM</h3>
              <p className="text-gray-600">First to introduce in India – same-day crowns & restorations</p>
            </div>
            <div className="text-center p-6 border rounded-lg hover:shadow-lg transition">
              <div className="text-5xl text-blue-600 mb-4">🔬</div>
              <h3 className="text-xl font-bold mb-2">Dental Implants</h3>
              <p className="text-gray-600">Sophisticated, high-quality implant systems with no compromise</p>
            </div>
            <div className="text-center p-6 border rounded-lg hover:shadow-lg transition">
              <div className="text-5xl text-blue-600 mb-4">Laser</div>
              <h3 className="text-xl font-bold mb-2">Laser Dentistry</h3>
              <p className="text-gray-600">Painless procedures – first of its kind in India</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;